// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';

import { Support, SupportReply } from '../../types/Model';
import { RootAction, actionCreatorsList } from '../rootActionCreator';

export interface replySupportPageState {
  data: Support | {};
  isLoading: boolean;
  error?: Error;
}

const {
  replySupportActions,
} = actionCreatorsList;

export const initialState: replySupportPageState = {
  data: {},
  isLoading: false,
};

const replySupportReducer = (state = initialState, action: RootAction): replySupportPageState => {
  switch (action.type) {
    case getType(replySupportActions.request): {
      return {
        ...state,
        isLoading: true,
        error: undefined
      };
    }
    case getType(replySupportActions.success): {
      const { data } = action.payload
      return {
        ...state,
        isLoading: false,
        data
      };
    }
    case getType(replySupportActions.failure): {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    default: {
      return state;
    }
  }
}

export { replySupportReducer as default };
